// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonToggle = 'Pill';
var ButtonToggleGroup = 'Pill';
var ButtonDefault = 'Pill';
var IconButtonDefault = 'Circle';
var Field = 'Rectangle';
var PaginationNumbered = 'Rectangle';
var Stepper = 'Pill';
var TagDefault = 'Rectangle';
var Toast = 'Rectangle';
var Tooltip = 'Rectangle';
var ShapeSemanticsAll = {
  ButtonDefault: ButtonDefault,
  ButtonToggle: ButtonToggle,
  ButtonToggleGroup: ButtonToggleGroup,
  Field: Field,
  IconButtonDefault: IconButtonDefault,
  PaginationNumbered: PaginationNumbered,
  Stepper: Stepper,
  TagDefault: TagDefault,
  Toast: Toast,
  Tooltip: Tooltip
};

export { ButtonDefault, ButtonToggle, ButtonToggleGroup, Field, IconButtonDefault, PaginationNumbered, ShapeSemanticsAll, Stepper, TagDefault, Toast, Tooltip, ShapeSemanticsAll as default };
